import { gql, useMutation } from '@apollo/client';

export const AUDIT_DOCUMENT_GENERATION_MUTATION = gql`
  mutation AuditDocumentGeneration($applicationId: String!) {
    auditDocumentGeneration(applicationId: $applicationId)
  }
`;

interface AuditDocumentGenerationMutationResult {
  auditDocumentGeneration: boolean;
}

export interface AuditDocumentGenerationMutationVariables {
  applicationId: string;
}

export const useAuditDocumentGenerationMutation = () => {
  return useMutation<AuditDocumentGenerationMutationResult, AuditDocumentGenerationMutationVariables>(
    AUDIT_DOCUMENT_GENERATION_MUTATION
  );
};

